import catalog from "./data.json";

// Descriptions follow the existing product portfolio and its interface captures.
export const agentProducts = [
  {
    id: "shiye-agent",
    name: "Shiye Agent",
    category: "Enterprise agent platform",
    url: "https://shiyeagent.com",
    summary: "Build business agents around solution packs, reusable skills and your team's knowledge.",
    audience: "Marketing, customer support, e-commerce and business operations teams.",
    features: [
      { title: "Start with a solution pack", text: "Explore packs for cross-border marketing, customer support, game operations and e-commerce. Bring a defined business task into the agent workspace." },
      { title: "Bring skills and knowledge together", text: "Work with Skills, Knowledge and Memory alongside agents and workflows, so your team can organise the resources behind each task." },
      { title: "Manage the work in one platform", text: "Use dedicated areas for teams, chat, tools and deployment, with dashboard views for model usage and token costs." },
    ],
    example: "Plan a cross-border campaign: research competitors, prepare multilingual copy and organise a weekly performance review.",
  },
  {
    id: "super-agent",
    name: "Super Agent",
    category: "Multi-agent collaboration workspace",
    url: "https://agent.thinkloop.me",
    summary: "Bring specialist agents into a shared workspace for analysis, operational tasks and project outputs.",
    audience: "IT operations, software teams and teams coordinating work across specialist roles.",
    features: [
      { title: "Create teams of specialist agents", text: "Organise roles such as root-cause engineer, alert analyst, code engineer and document specialist around a shared task." },
      { title: "Work through a shared conversation", text: "Use group chat and agent mentions to coordinate work. Sessions, memory, outputs and a file manager sit alongside the conversation." },
      { title: "Explore operational tasks", text: "The workspace includes starting points for root-cause analysis, alert patterns, recovery planning, system API connections and timeline reconstruction." },
    ],
    example: "Investigate a service incident with an analysis team, then prepare a timeline and a draft recovery plan for human review.",
  },
].map(product => ({
  ...product,
  image: catalog.Gallery.find(item => item.url === product.url)?.largeImage,
}));

export const specialistApplications = [
  {
    id: "ai-sport",
    name: "AI Sport",
    category: "Sports analysis",
    summary: "Explore match schedules and AI-generated reports based on team rankings, recent performance, and attacking and defensive data.",
    output: "Match analysis, result probabilities and score forecasts.",
    note: "Forecasts are estimates, not guaranteed match outcomes.",
    url: "https://aisport.one",
    image: catalog.Gallery.find(item => item.url === "https://aisport.one")?.largeImage,
  },
  {
    id: "study-abroad",
    name: "AI Study Abroad Planning",
    category: "Education planning",
    summary: "Bring academic background, language proficiency and interests into a structured assessment for overseas study planning.",
    output: "Profile assessment, school and major recommendations, and application planning.",
    note: "Discuss this application with our team.",
    image: catalog.Gallery.find(item => item.title.startsWith("AI Study Abroad Planning"))?.largeImage,
  },
];

export const agentScenarios = [
  { name: "Customer support", product: "Shiye Agent", target: "shiye-agent", task: "Organise service knowledge, prepare answers to routine enquiries and explore ticket-routing tasks." },
  { name: "Cross-border marketing", product: "Shiye Agent", target: "shiye-agent", task: "Connect competitor research, multilingual content and campaign review around a repeatable marketing brief." },
  { name: "IT operations", product: "Super Agent", target: "super-agent", task: "Bring specialist roles together to investigate alerts, reconstruct incidents and draft recovery plans." },
  { name: "Project handover", product: "Super Agent", target: "super-agent", task: "Coordinate case analysis, code-related tasks and documentation in a shared team workspace." },
];
